// extracted by mini-css-extract-plugin
module.exports = {"icon":"HwidMatchModePicker_icon__WoP69"};